/* Mobile sticky add to cart.

   Prestige's own <product-sticky-bar> reveals itself only once the entire
   product form has scrolled above the viewport. The bundle widget makes that
   form ~1400px tall, so on this product the bar arrives long after the shopper
   needed it. This shows it whenever the inline Add to cart button is off
   screen and the footer is not in view, which includes the first paint.

   The state lives on <body> so a variant change re-rendering the bar cannot
   drop it. */
(() => {
  const mobile = window.matchMedia('(max-width: 699px)');

  let inlineButton = null;
  let footer = null;

  const onScreen = (element) => {
    if (!element) return false;
    const box = element.getBoundingClientRect();
    return box.bottom > 0 && box.top < window.innerHeight;
  };

  const update = () => {
    document.body.classList.toggle(
      'ise-sticky-on',
      mobile.matches && !onScreen(inlineButton) && !onScreen(footer)
    );
  };

  const init = () => {
    if (!document.querySelector('product-sticky-bar')) return;

    inlineButton = document.querySelector('.product-info buy-buttons');
    if (!inlineButton) return;

    footer = document.querySelector('.shopify-section--footer');

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    mobile.addEventListener('change', update);

    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Sticky bar mirrors the buy box.

   The Kaching bundle widget, not the theme, decides what actually gets added,
   and it defaults to the Essential Duo. Prestige meanwhile renders the single
   variant into the sticky bar, so the bar advertised $64.95 for a $99.95 add.

   Two halves: copy the selected deal's name and price into the bar, and forward
   the bar's button to the real Add to cart so whatever the app has bound there
   runs unchanged rather than being guessed at. */
(() => {
  const SELECTED_DEAL = '.kaching-bundles__bar--selected';
  const TITLE = '.product-sticky-bar__info > .h-stack > .v-stack > span.h6';

  const setText = (element, text) => {
    if (!element || element.textContent.trim() === text) return;
    element.textContent = text;
  };

  /* sale-price and compare-at-price each open with a visually hidden label, so
     rebuild the element around that label instead of overwriting it. */
  const setAmount = (element, amount) => {
    if (!element || element.dataset.iseAmount === (amount || '')) return;
    element.dataset.iseAmount = amount || '';

    if (!amount) {
      element.hidden = true;
      return;
    }

    element.hidden = false;
    const label = element.querySelector('.sr-only');
    element.textContent = '';
    if (label) element.appendChild(label);
    element.appendChild(document.createTextNode(amount));
  };

  /* Show the material groups for whatever the selected deal contains, so the
     duo lists both bracelets' stones rather than only this product's. */
  const syncMaterials = (deal) => {
    const wrapper = document.querySelector('.ise-materials');
    if (!wrapper) return;

    const groups = [...wrapper.querySelectorAll('.ise-materials__group')];
    if (!groups.length) return;

    const inDeal = deal
      ? [...deal.querySelectorAll('.kaching-bundles__bundle-products__title')].map((el) =>
          el.textContent.trim()
        )
      : [];
    let wanted = inDeal.length ? inDeal : [wrapper.dataset.defaultProduct];

    /* A bundle can contain something with no material group of its own, such as
       the care plan. Never end up showing nothing. */
    if (!groups.some((group) => wanted.includes(group.dataset.product))) {
      wanted = [wrapper.dataset.defaultProduct];
    }

    let shown = 0;
    for (const group of groups) {
      const visible = wanted.includes(group.dataset.product);
      group.hidden = !visible;
      if (visible) shown += 1;
    }

    wrapper.classList.toggle('ise-materials--multi', shown > 1);
  };

  const sync = () => {
    const bar = document.querySelector('product-sticky-bar');
    const deal = document.querySelector(SELECTED_DEAL);

    syncMaterials(deal);

    if (!bar || !deal) return;

    const price = deal.querySelector('.kaching-bundles__bar-price');
    if (!price) return;

    const fullPrice = deal.querySelector('.kaching-bundles__bar-full-price');
    const title = deal.querySelector('.kaching-bundles__bar-title');

    setText(bar.querySelector(TITLE), title ? title.textContent.trim() : '');
    setAmount(bar.querySelector('sale-price'), price.textContent.trim());
    setAmount(bar.querySelector('compare-at-price'), fullPrice ? fullPrice.textContent.trim() : '');
  };

  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    setTimeout(() => {
      pending = false;
      sync();
    }, 50);
  };

  const init = () => {
    const bar = document.querySelector('product-sticky-bar');
    if (!bar) return;

    const observer = new MutationObserver(schedule);

    /* Watch the buy box rather than the bundle widget itself: the app injects
       that widget after DOMContentLoaded, so observing it directly would attach
       to nothing and leave the bar showing the single variant on first paint. */
    const buyBox = document.querySelector('.product-info');
    if (buyBox) {
      observer.observe(buyBox, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    /* The theme re-renders the bar on variant change, which drops our text. */
    if (bar.parentElement) {
      observer.observe(bar.parentElement, { subtree: true, childList: true });
    }

    document.addEventListener('change', (event) => {
      if (event.target.closest('kaching-bundles-block')) schedule();
    });

    document.addEventListener(
      'click',
      (event) => {
        const stickyButton = event.target.closest('product-sticky-bar button[type="submit"]');
        if (!stickyButton) return;

        const realButton = document.querySelector('.product-info buy-buttons button[type="submit"]');
        if (!realButton || realButton.disabled) return;

        event.preventDefault();
        event.stopPropagation();
        realButton.click();
      },
      true
    );

    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
